<template>
  <section>
    <div class="row mb-5">
      <div class="col-12">
        <template v-if="!warningText && examinationDetail">
          <div class="row mt-5">
            <div class="col-12">
              <div class="btn btn-lg" id="state_question">ข้อ {{ parseFloat(countHasDone) + 1 }} /
                {{ countAll }}
              </div>
            </div>
          </div>

          <transition name="fade">
            <div class="row mt-5" v-if="examinationDetail.question && fadeShow">
              <div class="col-12">
                <h3 style="line-height: 1.8;" v-html="convertLineBreaks(examinationDetail.question.name)">
                </h3>
                <div v-if="examinationDetail.question.image_url">
                  <img class="img-fluid mb-3 w-100" style="object-fit: cover; border: 2px solid #dee2e6;" :src="examinationDetail.question.image_url" alt="">
                </div>
              </div>
            </div>
          </transition>


          <form @submit.prevent="checkAnswer"
                v-if="examinationDetail.question && examinationDetail.question.question_answers">

            <transition name="fade">

              <div class="row mb-5" v-if="fadeShow">

                <div class="col-12">
                  <hr style="margin: 10px 0 20px 0;">
                  <div class="card" v-for="(item, index) in examinationDetail.question.question_answers"
                       :key="item.id + '-' + index">
                    <label class="card-body mb-0" style="padding-left: 2rem;" :for="`exam-${item.id}`"
                           :class="{'active-box' : formData.question_answer_id === item.id}">

                      <input class="form-check-input"
                             type="radio" name="exampleRadios"
                             v-model="formData.question_answer_id"
                             :id="`exam-${item.id}`" :value="item.id">

                      <span class="form-check-label">
                        {{ getThaiIndex(index) }} <span v-html="convertLineBreaks(item.name)"></span>
                      </span>
                      <div v-if="item.image_url">
                        <img class="img-fluid mt-2 w-100" style="object-fit: cover;" :src="item.image_url" alt="">
                      </div>
                    </label>
                  </div>


                  <button :disabled="submitting || !formData.question_answer_id"
                          class="mt-3 btn btn-block btn-lg btn-info" type="submit">ส่งคำตอบ
                  </button>

                </div>
              </div>
            </transition>

          </form>

        </template>

        <template v-else>

          <div class="text-center mt-5">
            <template v-if="warningCode == 200">
              <i class="fas fa-3x fa-exclamation-circle text-warning"></i>

            </template>
            <template v-else-if="warningCode == 204">
              <i class="fas fa-3x fa-check-circle text-success"></i>
            </template>

            <h2 class="mt-3">{{ warningText }}</h2>

            <template v-if="score">
              <h2>คุณได้คะแนนรวม <br> {{ score }} / {{ countAll }} คะแนน</h2>
              <router-link :to="{name: 'Admin Tests', params: { id: adminId }, query: { validationCode: validationCode }}"
                           class="mt-3 btn btn-block btn-lg btn-success">กลับไปยังหน้ารายการ
              </router-link>
            </template>
          </div>

        </template>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Examination',
  data () {
    return {
      fadeShow: true,
      formData: {
        question_answer_id: null
      },
      score: null,
      countAll: 0,
      countHasDone: 0,
      examinationDetail: null,
      warningText: '',
      warningCode: '',
      submitting: false,
      adminId: '',
      testId: '',
      validationCode: ''
    }
  },
  methods: {
    getThaiIndex (index) {
      if (index === 0) {
        return 'ก. '
      } else if (index === 1) {
        return 'ข. '
      } else if (index === 2) {
        return 'ค. '
      } else if (index === 3) {
        return 'ง. '
      }
      return ''
    },
    convertLineBreaks (text) {
      return text.replace(/\n/g, '<br>')
    },
    async fetchExaminationDetails () {
      await this.checkProfessionalExamination()
    },
    async checkProfessionalExamination () {
      this.$swal.showLoading()
      this.warningText = ''
      this.warningCode = ''
      try {
        // เช็คแบบทดสอบว่ามีอยู่มั้ย
        let { data } = await axios.post(`professional/examinations/${this.testId}/check-examination`)
        if (data.error) {
          this.warningText = data.message
          this.warningCode = data.code
          if (data.hasOwnProperty('score')) {
            this.score = data.score
            this.countAll = data.count_all
          }
          this.$swal.close()
        } else {
          await this.setProfessionalExamination(data.examination_id)
          this.$swal.close()
        }
      } catch (err) {
        this.$swal({ text: err, type: 'error' })
      }
    },
    async setProfessionalExamination (examinationId) {
      this.warningText = ''
      this.fadeShow = false
      try {
        let { data } = await axios.get(`professional/examinations-detail/${examinationId}`, {
          params: {
            validation_code: this.validationCode
          }
        })
        if (!data.error) {
          this.countAll = data.count_all
          this.countHasDone = data.count_has_done
          this.examinationDetail = data.examination_detail
        } else {
          if (data.hasOwnProperty('score')) {
            this.score = data.score
          }
          this.warningText = data.message
          this.warningCode = data.code
        }
        this.fadeShow = true
      } catch (err) {
        this.$swal({ text: err.response.data.message, type: 'error' })
      }
    },
    async checkAnswer () {
      let isCorrect = 0
      if (this.formData.question_answer_id === this.examinationDetail.question_answer_correct_id) {
        this.$swal({ text: 'ถูกต้อง', type: 'success' }).then(res => {
          isCorrect = 1
          this.submitExam(isCorrect)
        })
      } else {
        isCorrect = 0
        this.submitExam(isCorrect)
        this.$swal({
          title: 'คุณตอบผิดค่ะ',
          html: 'คำตอบที่ถูก คือ <br>' + this.examinationDetail.question_answer_correct_text,
          type: 'error'
        })
      }
    },
    async submitExam (isCorrect) {
      let params = {
        question_answer_id: this.formData.question_answer_id,
        is_correct: isCorrect
      }
      let { data } = await axios.put(`professional/examinations-detail/${this.examinationDetail.id}`, params)
      if (!data.error) {
        this.setProfessionalExamination(data.examination_detail.examination_id)
        this.formData.question_answer_id = null
      } else {
        this.$swal({
          text: 'ผิดพลาด ' + data.message,
          type: 'error'
        })
      }
    }
  },
  created () {
    this.adminId = this.$route.params.id
    this.testId = this.$route.params.testId
    this.validationCode = this.$route.query.validationCode
    this.fetchExaminationDetails()
  }
}
</script>

<style scoped lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .1s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

div#state_question {
  border: 1px solid #00BCD4 !important;
  color: #00BCD4 !important;

  &:hover, &:active {
    background: none;
    cursor: auto;
  }
}

div.box-label, label.box-label {
  display: block;
  padding: 1rem;
  padding-left: 2rem;
  border: 1px solid black;
  margin-top: 1rem;
  position: relative;
  border-radius: 4px;

  &:hover {
    border: 1px solid #17a2b8;
    cursor: pointer;
  }
}

.active-box {
  /*border: 2px solid #00BCD4 !important;
  border-radius: 4px;
  -webkit-box-sizing:border-box;
  -moz-box-sizing:border-box;
  -ms-box-sizing:border-box;
  box-sizing:border-box;*/
  box-shadow:0 0 0 2px #00BCD4;
}
</style>



// WEBPACK FOOTER //
// src/components/temp/AdminTest.vue